<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.yeni_marka_projesi"  url="BrandProjects" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>
<p class="hidden">{{preflang_id}}</p>

<form @submit.prevent="submitForm" class="mt-4">
<div class="grid">
<div class="col-12 md:col-6">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>
<div class="col-12 md:col-6">
<InputCalendarValidate :data="fields[2]" :fieldindex="2" @emitValue="inputValueEmitted"></InputCalendarValidate>
</div>  
<div class="col-12 md:col-6">
<InputSwitchValidate :data="fields[1]" :fieldindex="1" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>
<div class="col-12 md:col-6">
<InputNumberValidate :data="fields[3]" :fieldindex="3" @emitValue="inputValueEmitted" ></InputNumberValidate>
</div>

<div class="col-12">
<InputMultiSelectValidate :data="fields[4]" :fieldindex="4" @emitValue="inputValueEmitted"></InputMultiSelectValidate>
</div>


</div>










<div class="flex justify-content-end flex-wrap mt-3">
 <Button :label="$store.state.languages.lang_phrases.kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>



</form>


</div>
</template>

<script>
export default {

  name: 'CreateBrandProject',

  data () {
    return {   
    	languages:[],
    	fields:[
	      {
	        title:this.$store.state.languages.lang_phrases.isim,
	        key:"name",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:1000,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Periyodik",
	        key:"is_periodic",
	        type:"switch",
	        value:false,
	        show:true,
	      },
	      {
	        title:"Başlangıç Tarihi",
	        key:"start_date",
	        type:"date",
	        value:null,
	        is_required:true,
	        show:true,
	      },
	      {
	        title:"Periyot (gün)",
	        key:"period",
	        type:"number",
	        value:120,
	        steps:15,
	        show:false
	      },
	      {
        title:"dahil_diller",
        key:"available_languages",
        type:"multiselect",
        value:[],
        is_required:true,
        has_error:false,
        error_message:null,
        show:true,
        options:[],
      }

      ]
    }
  },
  computed:{
    preflang_id()
    {
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:
  {
    preflang_id()
    {
      setTimeout(()=>{
        this.fields[0].title = this.$store.state.languages.lang_phrases.isim
        this.fields[1].title = this.$store.state.languages.lang_phrases.periyodik
        this.fields[2].title = this.$store.state.languages.lang_phrases.baslangic_tarihi
        this.fields[3].title = this.$store.state.languages.lang_phrases.periyot_gun
      },500)
      
    }
  },
  async mounted()
  {
  	this.languages = await this.generalApiGetWithoutLoader("languages") 
  	this.fields[4].options = await this.languages
  },
  methods:{
  	 submitForm()
    {

        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
        console.log(validated)
    },
    inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false   
      if(data.index==1)  
      {
      	if(data.value)
      	{
      		this.fields[3].show = true
      	}
      	else
      	{
      		this.fields[3].show = false
      	}
      }
    },
    submit()
    {         
      let formdata = this.createFormData(JSON.parse(JSON.stringify(this.fields)))
      console.log(formdata)
      formdata.append("brand_id",this.$route.params.id)    
      //formdata.append("data",JSON.stringify(this.fields))
      this.generalSubmission(formdata,"project/store",this.afterSubmit)
    },
    afterSubmit(response)
    {
        console.log(response)
        if(response.status==400)
        {
            this.showerror = true
            this.errormessage = response.data.errors[0].message
        } 
        else
        {
        	this.$router.push({ name: 'Project', params: { id:response.data.id } })
        }
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>